import { render, staticRenderFns } from "./ExportRecipeWarning.vue?vue&type=template&id=b7871d62&"
import script from "./ExportRecipeWarning.vue?vue&type=script&lang=js&"
export * from "./ExportRecipeWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports